import { FormBuilderFieldInputType } from "@/constants/form-builder";
import {
  type FormBuilderFormEntity,
  type FormBuilderFormField,
} from "@/types/form-builder";

export function getFormFields(
  formEntity: FormBuilderFormEntity,
): FormBuilderFormField[] {
  const fields: FormBuilderFormField[] = [];

  formEntity.data.rows.forEach((row) => {
    row.columns.forEach((field) => {
      if (
        field.inputType &&
        field.inputType !== FormBuilderFieldInputType.None
      ) {
        fields.push(field);
      }
    });
  });

  return fields;
}
